import NameAvatar from "components/custom/nameAvatar"
import { swalWithConfirmAndCancelButtons } from "components/custom/swal"
import SyncfusionGrid from "components/custom/Syncfusion/SyncfusionGrid"
import UploadModal from "components/GlobalModals.js/UploadModal"
import useModal from "hooks/useModalHook"
import React, { useEffect, useRef, useState } from "react"
import Loader from "react-loaders"
import { toast } from "react-toastify"
import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Row,
} from "reactstrap"
import api from "services/api.service"
import { userService } from "services/user.service"
import colors from "utils/colors"

const UsersGrid = ({
  users,
  isLoading,
  setUser,
  toggleEditModal,
  reloadData,
}) => {
  const currentUser = userService.getLoggedInUser()
  var gridRef = useRef(null)
  const [showActionsDropdown, setShowActionsDropdown] = useState(false)
  const { show: showUploadUsersModal, toggle: toggleUploadUsersModal } =
    useModal()
  const [columns, setColumns] = useState([])

  const [elementsCount, setElementsCount] = useState(0)

  useEffect(() => {
    if (users != undefined && users != null && users.length > 0) {
      setColumns(loadColumns())
    }
  }, [users])

  const handleNamePress = (e, user) => {
    e && e.preventDefault()
    setUser(user)
    toggleEditModal()
  }

  const loadColumns = () => {
    return [
      {
        type: "checkbox",
        width: 50,
      },
      {
        headerText: "Name",
        field: "fullName",
        template: data => (
          <a href="#" onClick={e => handleNamePress(e, data)}>
            <NameAvatar
              fullName={data.fullName}
              showName={true}
              aiUser={data.aiUser}
              base64Image={data.photoBase64}
            />
          </a>
        ),
      },
      {
        headerText: "Email",
        field: "email",
      },
      {
        headerText: "Enterprise",
        field: "enterprise",
      },
      {
        headerText: "Role",
        field: "role",
        filter: {
          type: "Excel",
          itemTemplate: data => {
            return (
              <div
                style={{ lineHeight: "20px" }}
                dangerouslySetInnerHTML={{
                  __html: data.role,
                }}
              ></div>
            )
          },
        },
        template: data => (
          <div
            style={{ lineHeight: "20px" }}
            dangerouslySetInnerHTML={{
              __html: data.role,
            }}
          ></div>
        ),
      },
      {
        headerText: "State",
        field: "inactive",
        filter: {
          type: "Excel",
          itemTemplate: data => (data.inactive == 0 ? "Active" : "Inactive"),
        },
        template: data => {
          return data.inactive == 0 ? (
            <span style={{ color: "green" }}>Active</span>
          ) : (
            <span style={{ color: "red" }}>
              <b>Inactive</b>
            </span>
          )
        },
      },
    ]
  }

  const deleteSelected = () => {
    swalWithConfirmAndCancelButtons
      .fire({
        title: `Are you sure you want to delete the selected users?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        reverseButtons: true,
      })
      .then(async result => {
        if (result.isConfirmed) {
          let selected = gridRef.current.getSelectedRecords()
          if (selected.length > 0) {
            let tasks = selected.map(x => async () => {
              return await api.deleteUser(currentUser.userID, x.userID)
            })
            await Promise.all(tasks.map(t => t()))
            reloadData()
            toast.success("Users deleted successfully")
          }
        }
      })
  }

  const uploadUsers = async file => {
    return await api.uploadUsers(
      currentUser.userID,
      currentUser.enterpriseID,
      file
    )
  }

  return (
    <React.Fragment>
      {isLoading && (
        <Loader
          type="line-scale-pulse-out"
          color={colors.primary}
          style={{ textAlign: "center" }}
        />
      )}
      {!isLoading && users.length > 0 && (
        <>
          <Row>
            <Col
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "end",
              }}
            >
              <Dropdown
                className="save-user"
                isOpen={showActionsDropdown}
                toggle={() => setShowActionsDropdown(!showActionsDropdown)}
              >
                <DropdownToggle
                  tag="button"
                  className="btn btn-sm btn-outline-primary"
                >
                  Actions <i className="mdi mdi-chevron-down" />
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => toggleUploadUsersModal()}>
                    <i className="fas fa-cloud-upload-alt"></i> Upload Users
                  </DropdownItem>
                  <DropdownItem onClick={() => deleteSelected()}>
                    <i className="fas fa-trash-alt"></i> Delete Users
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </Col>
          </Row>
          <Row>
            <Col>
              <Label>{elementsCount} Users</Label>
            </Col>
          </Row>
          {columns.length > 0 && (
            <SyncfusionGrid
              gridRef={gridRef}
              columns={columns}
              data={users}
              selectionSettings={{
                type: "Multiple",
                mode: "Row",
                checkboxOnly: true,
              }}
            />
           
          )}
        </>
      )}
      <UploadModal
        isOpen={showUploadUsersModal}
        toggleModal={toggleUploadUsersModal}
        text="Upload a file containing users"
        callback={uploadUsers}
        fileType="Users"
        reload={reloadData}
      />
    </React.Fragment>
  )
}

export default UsersGrid
